var gallery = [];
var newslider = [];

jQuery(document).ready(function() {

	function stopOwlPropagation(element) {
	    jQuery(element).on('to.owl.carousel', function(e) { e.stopPropagation(); });
	    jQuery(element).on('next.owl.carousel', function(e) { e.stopPropagation(); });
	    jQuery(element).on('prev.owl.carousel', function(e) { e.stopPropagation(); });
	    jQuery(element).on('destroy.owl.carousel', function(e) { e.stopPropagation(); });
	    jQuery(element).on('translated.owl.carousel', function(e) { e.stopPropagation(); });
	}
	stopOwlPropagation('.owl-carousel');

	if ( jQuery('.c-slider__wrap').length > 0 ) {

		jQuery('.c-slider').each(function(i) {
			
			if ( jQuery(this).find('.c-slider__slide').length > 1 ) {
				var el = jQuery(this);
				var thisslider = el.find('.c-slider__wrap');
				var i = i;

				gallery[i] = thisslider.owlCarousel({
					container: thisslider,
					items: 1,
					autoplay: true,
					autoplayTimeout: 7000,
					loop: true,
					controls: false,
					nav: false,
					dots: false,
					center: true,
					margin: 0,
					edgePadding: 0
					
				});
				

				el.find('.c-slider__prev').on('click', function() {
					gallery[i].trigger('prev.owl.carousel');
					return false;
				});
				el.find('.c-slider__next').on('click', function() {
					gallery[i].trigger('next.owl.carousel');
					return false;
				});

				gallery[i].on('resized.owl.carousel', function() {
					App.slideswcardsBgresize();
				});
			} else {
				jQuery(this).find('.c-slider__prev').remove();
				jQuery(this).find('.c-slider__next').remove();
			}

		});		
		
	}

	if ( jQuery('.c-latestnews__slider').length > 0 ) {

		jQuery('.c-latestnews__slider').each(function(i) {
			
			if ( jQuery(this).find('.c-posts__item').length > 1 ) {
				var el = jQuery(this);
				var thisslider = el.find('.c-posts__slider');
				var i = i;

				newslider[i] = thisslider.owlCarousel({
					container: thisslider,
					items: 1,
					autoplay: true,
					autoplayTimeout: 7000,
					loop: true,
					controls: false,
					nav: false,
					dots: false,
					center: false,
					margin: 0,
					edgePadding: 0,
					responsive : {
						0 : {
							items: 1
						},
						740 : {
							items: 3
						}
					}
					
				});
				

				el.find('.c-latestnews__slider-prev').on('click', function() {
					newslider[i].trigger('prev.owl.carousel');
					return false;
				});
				el.find('.c-latestnews__slider-next').on('click', function() {
					newslider[i].trigger('next.owl.carousel');
					return false;
				});

				newslider[i].on('resized.owl.carousel', function() {
					App.slideswcardsBgresize();
				});
			} else {
				jQuery(this).find('.c-latestnews__slider-prev').remove();
				jQuery(this).find('.c-latestnews__slider-next').remove();
			}

		});		
		
	}

	jQuery(".disable-owl-swipe").on("touchstart mousedown", function(e) {
	    // Prevent carousel swipe
	    e.stopPropagation();
	});

});